// extracted by mini-css-extract-plugin
export default {"wrapper-widgets":"styles_wrapper-widgets__LLoL+"};